import { render, staticRenderFns } from "./SmallBlogItem.vue?vue&type=template&id=301a6fe3&scoped=true&"
import script from "./SmallBlogItem.vue?vue&type=script&lang=js&"
export * from "./SmallBlogItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301a6fe3",
  null
  
)

export default component.exports